// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AnalysisReport.css - Professional PDF Report Component Styles */

.generate-report-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #4a6da7; /* Professional blue color */
  color: white;
  font-weight: 600;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin: 10px auto 0 auto;
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  width: auto;
  min-width: 250px;
}

.generate-report-button:hover {
  background-color: #3a5a8f;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.generate-report-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
}

.report-icon {
  font-style: normal;
  margin-right: 10px;
  font-size: 20px;
}

/* Report template - normally hidden but needs to be converted to HTML */
.hidden-report-template {
  position: absolute;
  left: -9999px;
  top: -9999px;
  width: 210mm; /* A4 width */
  background: white;
  padding: 20mm;
  box-sizing: border-box;
}

.report-content {
  font-family: 'Helvetica', Arial, sans-serif;
  color: #333;
  line-height: 1.6;
}

.report-header {
  text-align: center;
  margin-bottom: 40px;
}

.report-header h1 {
  font-size: 28px;
  color: #333;
  margin-bottom: 15px;
}

.report-header h2 {
  font-size: 16px;
  color: #666;
  font-style: italic;
  margin-bottom: 20px;
}

.report-section {
  margin-bottom: 40px;
}

.report-section h3 {
  font-size: 16px;
  color: #444;
  margin-bottom: 15px;
  padding-bottom: 5px;
  border-bottom: 1px solid #4A6DA7;
}

.kegg-table-cell {
  word-break: break-word;
  white-space: normal;
}

.kegg-table-header--index,
.kegg-table-cell--index {
  text-align: center;
  width: 60px;
  min-width: 60px;
}

.summary-info {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.info-row {
  display: flex;
  align-items: baseline;
  margin-bottom: 8px;
}

.info-row .label {
  font-weight: bold;
  min-width: 120px;
  color: #555;
}

.info-row .value {
  color: #666;
}

.normalization-info-row {
  align-items: flex-start;
}

.normalization-details-list {
  display: inline-flex;
  flex-direction: column;
  gap: 2px;
}

.normalization-details-line {
  display: block;
}

.summary-image {
  margin: 20px 0;
  text-align: center;
}

.summary-image img {
  max-width: 100%;
  height: auto;
}

.analysis-result {
  margin-bottom: 30px;
}

.analysis-result h4 {
  font-size: 14px;
  color: #555;
  margin-bottom: 15px;
}

.result-image {
  margin-bottom: 20px;
}

.image-caption {
  font-size: 10px;
  color: #666;
  font-style: italic;
  margin-bottom: 5px;
}

.result-image img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

.report-footer {
  text-align: center;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #eee;
  font-size: 8px;
  color: #999;
}

/* PDF loading overlay */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* PDF loading spinner */
.loading-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #4A6DA7;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

.loading-text {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Media print styles for result images (HTML version for PDF) */
@media print {
  .result-image {
    max-width: 100%;
    page-break-inside: avoid;
  }
  
  .report-section {
    page-break-before: always;
  }
  
  .report-section:first-child {
    page-break-before: avoid;
  }
  
  .report-header {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .report-title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-bottom: 5px;
  }
  
  .report-date {
    font-size: 14px;
    color: #666;
  }
  
  .report-summary {
    border: 1px solid #ddd;
    padding: 15px;
    margin-bottom: 20px;
    background-color: #f9f9f9;
  }
  
  .summary-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }
  
  .summary-label {
    font-weight: bold;
  }
}

/* Progress bar styles */
.progress-bar {
  width: 200px;
  height: 4px;
  background: #f3f3f3;
  border-radius: 2px;
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  background: #4A6DA7;
  transition: width 0.3s ease;
}

/* Generate Report Button - disabled state */
.generate-report-button:disabled {
  background-color: #b9c5d9;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
} 

/* Biomarker validation UI */
.validation-action-bar {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 6px;
  margin-top: 25px !important;
  margin-bottom: 12px !important;
}

.validation-select-label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  color: #31456a;
  font-weight: 600;
}

.validation-select-label select {
  padding: 6px 10px;
  border: 1px solid #cfd7e6;
  border-radius: 4px;
  font-size: 16px;
  color: #1f2a44;
  background-color: #fff;
}

.biomarker-validation-button {
  background-color: #1f8a70;
  border: none;
  color: #fff;
  padding: 10px 18px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.2s ease;
}

.biomarker-validation-button:disabled {
  background-color: #9fbeb5;
  cursor: not-allowed;
}

.validation-status-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.validation-hint {
  font-size: 13px;
  color: #777;
}

.validation-error-text {
  font-size: 13px;
  color: #c0392b;
}

.validation-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.validation-or-separator {
  font-weight: 700;
  line-height: 1;
  text-align: center;
  color: #000;
}

.validation-results-panel {
  border: 1px solid #e0e6ef;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 24px;
  background-color: #f8fbff;
  width: 100%;
  min-width: 950px;
  max-width: 950px;
  display: flex;
  flex-direction: column;
  align-self: center;
}

.validation-results-header {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.validation-meta-line {
  margin: 0;
  font-size: 13px;
  color: #555;
}

.validation-results-meta {
  display: flex;
  gap: 12px;
  align-items: center;
  font-size: 13px;
  color: #555;
  flex-wrap: wrap;
}

.validation-tabs {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin: 8px 0 12px;
}

.validation-tab-button {
  border: 1px solid #d4ddf0;
  background: #f4f7ff;
  color: #2d3c5a;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s ease;
}

.validation-tab-button:hover {
  background: #e8edfb;
}

.validation-tab-button.active {
  background: #3f72ff;
  color: #fff;
  border-color: #3f72ff;
  box-shadow: 0 2px 6px rgba(63, 114, 255, 0.25);
}

.validation-score-note {
  margin: 0 0 0px;
  font-size: 12px;
  color: #3c4b6a;
}

.validation-download-button {
  border: 1px solid #3f72ff;
  background: transparent;
  color: #3f72ff;
  padding: 6px 14px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s ease;
}

.validation-download-button:hover {
  background: #3f72ff;
  color: #fff;
}

.validation-table-wrapper {
  margin-top: 16px;
  overflow-x: auto;
}

.validation-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 760px;
  font-size: 13px;
}

.validation-table th,
.validation-table td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #e5ebf3;
}

.validation-table thead th {
  background: #eff3fb;
  font-weight: 600;
  color: #233142;
}

.validation-table tbody tr:nth-child(odd) {
  background: #fff;
}

.validation-table tbody tr:nth-child(even) {
  background: #fdfdff;
}

.validation-table tbody tr:hover {
  background: #f4f8ff;
}

.validation-empty-state {
  margin: 12px 0 0;
  font-size: 14px;
  color: #5c6372;
}

`, "",{"version":3,"sources":["webpack://./src/css/step9-generateAnalysisReport.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB,EAAE,4BAA4B;EACvD,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,yBAAyB;EACzB,wCAAwC;EACxC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY,EAAE,aAAa;EAC3B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;EACd,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,gEAAgE;AAChE;EACE;IACE,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,4CAA4C;AAC5C;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* AnalysisReport.css - Professional PDF Report Component Styles */\n\n.generate-report-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #4a6da7; /* Professional blue color */\n  color: white;\n  font-weight: 600;\n  padding: 12px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  margin: 10px auto 0 auto;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  width: auto;\n  min-width: 250px;\n}\n\n.generate-report-button:hover {\n  background-color: #3a5a8f;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.generate-report-button:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);\n}\n\n.report-icon {\n  font-style: normal;\n  margin-right: 10px;\n  font-size: 20px;\n}\n\n/* Report template - normally hidden but needs to be converted to HTML */\n.hidden-report-template {\n  position: absolute;\n  left: -9999px;\n  top: -9999px;\n  width: 210mm; /* A4 width */\n  background: white;\n  padding: 20mm;\n  box-sizing: border-box;\n}\n\n.report-content {\n  font-family: 'Helvetica', Arial, sans-serif;\n  color: #333;\n  line-height: 1.6;\n}\n\n.report-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.report-header h1 {\n  font-size: 28px;\n  color: #333;\n  margin-bottom: 15px;\n}\n\n.report-header h2 {\n  font-size: 16px;\n  color: #666;\n  font-style: italic;\n  margin-bottom: 20px;\n}\n\n.report-section {\n  margin-bottom: 40px;\n}\n\n.report-section h3 {\n  font-size: 16px;\n  color: #444;\n  margin-bottom: 15px;\n  padding-bottom: 5px;\n  border-bottom: 1px solid #4A6DA7;\n}\n\n.kegg-table-cell {\n  word-break: break-word;\n  white-space: normal;\n}\n\n.kegg-table-header--index,\n.kegg-table-cell--index {\n  text-align: center;\n  width: 60px;\n  min-width: 60px;\n}\n\n.summary-info {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n}\n\n.info-row {\n  display: flex;\n  align-items: baseline;\n  margin-bottom: 8px;\n}\n\n.info-row .label {\n  font-weight: bold;\n  min-width: 120px;\n  color: #555;\n}\n\n.info-row .value {\n  color: #666;\n}\n\n.normalization-info-row {\n  align-items: flex-start;\n}\n\n.normalization-details-list {\n  display: inline-flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.normalization-details-line {\n  display: block;\n}\n\n.summary-image {\n  margin: 20px 0;\n  text-align: center;\n}\n\n.summary-image img {\n  max-width: 100%;\n  height: auto;\n}\n\n.analysis-result {\n  margin-bottom: 30px;\n}\n\n.analysis-result h4 {\n  font-size: 14px;\n  color: #555;\n  margin-bottom: 15px;\n}\n\n.result-image {\n  margin-bottom: 20px;\n}\n\n.image-caption {\n  font-size: 10px;\n  color: #666;\n  font-style: italic;\n  margin-bottom: 5px;\n}\n\n.result-image img {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  margin: 0 auto;\n}\n\n.report-footer {\n  text-align: center;\n  margin-top: 40px;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n  font-size: 8px;\n  color: #999;\n}\n\n/* PDF loading overlay */\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.9);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n/* PDF loading spinner */\n.loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 5px solid #f3f3f3;\n  border-top: 5px solid #4A6DA7;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n.loading-text {\n  font-size: 16px;\n  color: #333;\n  margin-bottom: 10px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Media print styles for result images (HTML version for PDF) */\n@media print {\n  .result-image {\n    max-width: 100%;\n    page-break-inside: avoid;\n  }\n  \n  .report-section {\n    page-break-before: always;\n  }\n  \n  .report-section:first-child {\n    page-break-before: avoid;\n  }\n  \n  .report-header {\n    text-align: center;\n    margin-bottom: 20px;\n  }\n  \n  .report-title {\n    font-size: 24px;\n    font-weight: bold;\n    color: #333;\n    margin-bottom: 5px;\n  }\n  \n  .report-date {\n    font-size: 14px;\n    color: #666;\n  }\n  \n  .report-summary {\n    border: 1px solid #ddd;\n    padding: 15px;\n    margin-bottom: 20px;\n    background-color: #f9f9f9;\n  }\n  \n  .summary-item {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 8px;\n  }\n  \n  .summary-label {\n    font-weight: bold;\n  }\n}\n\n/* Progress bar styles */\n.progress-bar {\n  width: 200px;\n  height: 4px;\n  background: #f3f3f3;\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  background: #4A6DA7;\n  transition: width 0.3s ease;\n}\n\n/* Generate Report Button - disabled state */\n.generate-report-button:disabled {\n  background-color: #b9c5d9;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n} \n\n/* Biomarker validation UI */\n.validation-action-bar {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 25px !important;\n  margin-bottom: 12px !important;\n}\n\n.validation-select-label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 13px;\n  color: #31456a;\n  font-weight: 600;\n}\n\n.validation-select-label select {\n  padding: 6px 10px;\n  border: 1px solid #cfd7e6;\n  border-radius: 4px;\n  font-size: 16px;\n  color: #1f2a44;\n  background-color: #fff;\n}\n\n.biomarker-validation-button {\n  background-color: #1f8a70;\n  border: none;\n  color: #fff;\n  padding: 10px 18px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: background-color 0.2s ease;\n}\n\n.biomarker-validation-button:disabled {\n  background-color: #9fbeb5;\n  cursor: not-allowed;\n}\n\n.validation-status-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.validation-hint {\n  font-size: 13px;\n  color: #777;\n}\n\n.validation-error-text {\n  font-size: 13px;\n  color: #c0392b;\n}\n\n.validation-panel {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n\n.validation-or-separator {\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  color: #000;\n}\n\n.validation-results-panel {\n  border: 1px solid #e0e6ef;\n  border-radius: 6px;\n  padding: 16px;\n  margin-bottom: 24px;\n  background-color: #f8fbff;\n  width: 100%;\n  min-width: 950px;\n  max-width: 950px;\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n}\n\n.validation-results-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 12px;\n}\n\n.validation-meta-line {\n  margin: 0;\n  font-size: 13px;\n  color: #555;\n}\n\n.validation-results-meta {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  font-size: 13px;\n  color: #555;\n  flex-wrap: wrap;\n}\n\n.validation-tabs {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin: 8px 0 12px;\n}\n\n.validation-tab-button {\n  border: 1px solid #d4ddf0;\n  background: #f4f7ff;\n  color: #2d3c5a;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: all 0.2s ease;\n}\n\n.validation-tab-button:hover {\n  background: #e8edfb;\n}\n\n.validation-tab-button.active {\n  background: #3f72ff;\n  color: #fff;\n  border-color: #3f72ff;\n  box-shadow: 0 2px 6px rgba(63, 114, 255, 0.25);\n}\n\n.validation-score-note {\n  margin: 0 0 0px;\n  font-size: 12px;\n  color: #3c4b6a;\n}\n\n.validation-download-button {\n  border: 1px solid #3f72ff;\n  background: transparent;\n  color: #3f72ff;\n  padding: 6px 14px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: all 0.2s ease;\n}\n\n.validation-download-button:hover {\n  background: #3f72ff;\n  color: #fff;\n}\n\n.validation-table-wrapper {\n  margin-top: 16px;\n  overflow-x: auto;\n}\n\n.validation-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 760px;\n  font-size: 13px;\n}\n\n.validation-table th,\n.validation-table td {\n  padding: 10px 12px;\n  text-align: left;\n  border-bottom: 1px solid #e5ebf3;\n}\n\n.validation-table thead th {\n  background: #eff3fb;\n  font-weight: 600;\n  color: #233142;\n}\n\n.validation-table tbody tr:nth-child(odd) {\n  background: #fff;\n}\n\n.validation-table tbody tr:nth-child(even) {\n  background: #fdfdff;\n}\n\n.validation-table tbody tr:hover {\n  background: #f4f8ff;\n}\n\n.validation-empty-state {\n  margin: 12px 0 0;\n  font-size: 14px;\n  color: #5c6372;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
